export default __webpack_public_path__ + "static/media/paper17.96d84abd.JPG";